import { FC, PropsWithChildren, type ReactNode } from 'react';
import { Flex } from 'antd';
import styled from 'styled-components';

interface AlgorithmGraphCtaProps extends PropsWithChildren {
  heading?: string;
  button?: ReactNode;
}

export const AlgorithmGraphCta: FC<AlgorithmGraphCtaProps> = (props) => {
  const { heading, button, children } = props;

  return (
    <Cta vertical gap="middle" align="center">
      {children || (
        <>
          <h5>{heading}</h5>
          {button}
        </>
      )}
    </Cta>
  );
};

const Cta = styled(Flex)`
  z-index: 10;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
